/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途.
 */
import {
  crudRequest,
  getActualArrivalCars,
  getCarCount,
  getPlanDepartureCars,
  getWayCars,
  getPlanDepartureCarListApi,
} from '@/services/api';
import { getToDayTwoDays, getToDayTwoDays2 } from '@/utils/date';

import { GetOrganizationAuth } from '@/services/area';
import moment from 'moment';

const paramsForm = {
  dateRange: getToDayTwoDays(),
  centerFilter: '',
};

export default {
  namespace: 'vehicleMonitoringNew',
  state: {
    dateRange: paramsForm.dateRange,
    dateRange2: getToDayTwoDays2(),
    dateRange3: paramsForm.dateRange,
    centerFilter: paramsForm.centerFilter,
    defualtDateFormat: 'YYYY-MM-DD HH:mm:00',
    activeKey: '1', //  tabs key 1 在途 / 2 待卸 / 3 在装 / 4 待装 / 5 在卸
    viewAction: 1,

    wayCarsItem: [], // 在途
    actualArrivalCarsItem: [], // 已到达
    planDepartureCarsItem: [], // 计划发出
    volumeItem: [], // 运力
    loadedItem: [], // 待装

    carCountData: [],
    summaryDrawerIsShow: false,

    totalScreeningValue: 'one',
    totalScreeningOption: [
      { label: '全部', value: 'all' },
      { label: '一级分拨中心', value: 'one' },
      { label: '二级分拨中心', value: 'two' },
    ],
  },
  effects: {
    *getSelect(_, { put }) {
      // tms
      yield put({
        type: 'update',
        payload: { isTmsLoading: false },
      });
      crudRequest('/api/route/vehicleMonitoringIntransit/search');
      yield put({ type: 'vehicleMonitoringNewIntransit/getWayCarsData' }); // 在途
      yield put({ type: 'unloadedtableNew/getArrivalCarData' }); // 待卸
      yield put({ type: 'unLoadingTableNew/getUnloadindData' }); // 在卸
      yield put({ type: 'vehicleMonitoringNewLoading/getLoadingData' }); // 在装,待发
      yield put({ type: 'vehicleMonitoringNewLoading/getLoadedData' }); // 待装
    },
    *getTms(_, { call, put, select }) {
      console.log('查询车险');
      // tms
      yield put({
        type: 'update',
        payload: { isTmsLoading: false },
      });
      let query = yield select(({ vehicleMonitoringNew }) => {
        return {
          activeKey: vehicleMonitoringNew.activeKey,
          locationCode: vehicleMonitoringNew.centerFilter.code,
          startTime: moment(vehicleMonitoringNew.dateRange[0]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          endTime: moment(vehicleMonitoringNew.dateRange[1]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
        };
      });
      let query2 = yield select(({ vehicleMonitoringNew }) => {
        return {
          activeKey: vehicleMonitoringNew.activeKey,
          locationCode: vehicleMonitoringNew.centerFilter.code,
          startTime: moment(vehicleMonitoringNew.dateRange2[0]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          endTime: moment(vehicleMonitoringNew.dateRange2[1]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
        };
      });
      let query3 = yield select(({ vehicleMonitoringNew }) => {
        return {
          activeKey: vehicleMonitoringNew.activeKey,
          locationCode: vehicleMonitoringNew.centerFilter.code,
          startTime: moment(vehicleMonitoringNew.dateRange3[0]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          endTime: moment(vehicleMonitoringNew.dateRange3[1]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
        };
      });
      const result1 = yield call(getWayCars, {
        // 在途
        locationCode: query.locationCode,
        sign: 'ARRIVE', // DEPART
      });
      const result2 = yield call(getActualArrivalCars, query); // 实际已到达-待卸和在卸
      const result3 = yield call(getPlanDepartureCarListApi, query2); // 计划发出-在装和待发
      const result4 = yield call(getPlanDepartureCars, query3); // 计划出发-待装
      // const start = moment(query.startTime).day();
      // const departure = yield call(crudRequest3, {
      //   period: start === 0 ? 7 : start,
      //   departureCenter: query.locationName
      // })
      // const volumeItem = departure.data && departure.data.length > 0 ? departure.data : []
      yield put({
        type: 'update',
        payload: {
          wayCarsItem: result1.data || [],
          actualArrivalCarsItem: result2.data || [],
          planDepartureCarsItem: result3.data || [],
          loadedItem: result4.data || [],
          // volumeItem: volumeItem
        },
      });
      yield put({ type: 'getSelect' });
    },

    *getCarCount(_, { call, put, select }) {
      // tms
      yield put({
        type: 'update',
        payload: { isTmsLoading: false },
      });
      let query = yield select(({ vehicleMonitoringNew }) => {
        return {
          carQueryType: '1',
          startDate: moment(vehicleMonitoringNew.dateRange[1])
            .add(-1, 'day')
            .format(vehicleMonitoringNew.defualtDateFormat),
          endDate: moment(vehicleMonitoringNew.dateRange[1]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          // startDate: '2023-05-05 12:00:00',
          // endDate: '2023-05-11 12:00:00',
        };
      });
      const result = yield call(getCarCount, query);
      let datas =
        result?.data?.map((item) => ({
          ...item,
          allCount: item.waitUnloadAmount + item.unloadAmount,
        })) || [];
      datas = datas.map((item) => {
        return {
          ...item,
          organizationName: item.locationName,
          name: item.locationName,
          isLast: true,
        };
      });
      let groupData = Object.groupBy(datas, (item) => item.provinceAreaName);
      let generatedData = [];
      for (const key in groupData) {
        if (Object.hasOwnProperty.call(groupData, key)) {
          const element = groupData[key];
          let waitUnloadAmount = element?.reduce((acc, obj) => acc + obj.waitUnloadAmount, 0);
          let unloadAmount = element?.reduce((acc, obj) => acc + obj.unloadAmount, 0);
          let allCount = element?.reduce((acc, obj) => acc + obj.allCount, 0);
          generatedData.push({
            name: key,
            organizationName: key,
            waitUnloadAmount,
            unloadAmount,
            allCount,
            children: element,
          });
        }
      }
      yield put({
        type: 'update',
        payload: {
          carCountData: generatedData || [],
        },
      });
      console.log('遍历键值', generatedData);
      // for (const [key, value] of groupData) {

      //   // let waitUnloadAmount = value?.reduce((acc, obj) => acc.waitUnloadAmount + obj.waitUnloadAmount);
      //   // let unloadAmount = value?.reduce((acc, obj) => acc.unloadAmount + obj.unloadAmount);
      //   // let allCount = value?.reduce((acc, obj) => acc.allCount + obj.allCount);
      //   // generatedData.push({organizationName: key,waitUnloadAmount,unloadAmount,allCount,children:value });
      // }

      // let { carUnloadedMap, carUnLoadingMap } = result?.data || {};

      // // 根据taskNo去重
      // carUnloadedMap = Array.from(new Set(carUnloadedMap?.map(a => a.taskNo))).map(taskNo => {
      //   return carUnloadedMap.find(a => a.taskNo === taskNo);
      // });
      // carUnLoadingMap = Array.from(new Set(carUnLoadingMap?.map(a => a.taskNo))).map(taskNo => {
      //   return carUnLoadingMap.find(a => a.taskNo === taskNo);
      // });

      // let allProvinceList = {};

      // let maxLength = Math.max(carUnloadedMap?.length || 0, carUnLoadingMap?.length || 0);
      // for (let index = 0; index < maxLength; index++) {
      //   const unloaded = carUnloadedMap?.[index]; // 待卸
      //   const unloading = carUnLoadingMap?.[index]; // 在卸

      //   if (unloaded) {
      //     let provinceMap = allProvinceList[unloaded.provinceAreaName];
      //     if (!provinceMap) {
      //       provinceMap = {
      //         ...unloaded,
      //         name: unloaded?.provinceAreaName,
      //         unloadedCount: 0,
      //         unloadingCount: 0,
      //         allCount: 0,
      //         centerMap: {},
      //       };
      //       allProvinceList[unloaded.provinceAreaName] = provinceMap;
      //     }
      //     provinceMap.unloadedCount += 1;
      //     provinceMap.allCount += 1;

      //     let centerMap = provinceMap.centerMap[unloaded.locationName];
      //     if (!centerMap) {
      //       centerMap = {
      //         ...unloaded,
      //         name: unloaded?.locationName,
      //         unloadedCount: 0,
      //         unloadingCount: 0,
      //         allCount: 0,
      //         isLast: true,
      //       };
      //       provinceMap['centerMap'][unloaded.locationName] = centerMap;
      //     }
      //     centerMap.unloadedCount += 1;
      //     centerMap.allCount += 1;
      //   }
      //   if (unloading) {
      //     let provinceMap = allProvinceList[unloading.provinceAreaName];
      //     if (!provinceMap) {
      //       provinceMap = {
      //         ...unloading,
      //         name: unloading?.provinceAreaName,
      //         unloadedCount: 0,
      //         unloadingCount: 0,
      //         allCount: 0,
      //         centerMap: {},
      //       };
      //       allProvinceList[unloading.provinceAreaName] = provinceMap;
      //     }
      //     provinceMap.unloadingCount += 1;
      //     provinceMap.allCount += 1;

      //     let center = provinceMap.centerMap[unloading.locationName];
      //     if (!center) {
      //       center = {
      //         ...unloading,
      //         name: unloading?.locationName,
      //         unloadedCount: 0,
      //         unloadingCount: 0,
      //         allCount: 0,
      //         isLast: true,
      //       };
      //       provinceMap['centerMap'][unloading.locationName] = center;
      //     }
      //     center.unloadingCount += 1;
      //     center.allCount += 1;
      //   }
      // }

      // Object.values(allProvinceList).map(item => {
      //   item.children = item.centerMap ? Object.values(item.centerMap) : [];
      // });

      // let access = yield GetOrganizationAuth();

      // yield put({
      //   type: 'update',
      //   payload: {
      //     carCountData:
      //       access.isHead && Object.values(allProvinceList)?.length
      //         ? Object.values(allProvinceList)?.sort(
      //             (item1, item2) => item2.allCount - item1.allCount,
      //           ) || []
      //         : Object.values(allProvinceList || {})?.[0]?.children || [],
      //   },
      // });
      // yield put({ type: 'getSelect' });
    },
  },
  reducers: {
    update(state, { payload }) {
      // 处理搜索空间重制导致code丢失问题
      if ('centerFilter' in payload && state?.centerFilter?.name === payload?.centerFilter?.name) {
        const { centerFilter, ...other } = payload;
        return {
          ...state,
          ...other,
          centerFilter: { ...centerFilter, code: centerFilter?.code || state.centerFilter.code },
        };
      }
      return { ...state, ...payload };
    },
  },
};
